<template>
  <div class="forgotPassword">
    <el-form :model="formdata"
      v-if="showContent==='content'"
      style="width: 80%; margin: 0 auto"
      :rules="rules"
      ref="form">
      <el-form-item prop="phone">
        <el-input v-model="formdata.phone"
          placeholder="手机号"></el-input>
      </el-form-item>
      <el-form-item prop="code">
        <div style="display: flex">
          <el-input v-model="formdata.code"
            style="width: 54%"
            placeholder="验证码"></el-input>
          <div class="loginPageImgWrap"
            @click="getImgCode">
            <img :src="imgCode.image" />
          </div>
        </div>
      </el-form-item>
      <el-form-item prop="phoneCode">
        <el-input v-model="formdata.phoneCode"
          style="width: 54%"
          placeholder="短信验证码">
        </el-input>
        <el-button @click.prevent="sendCode()"
          :loading="loadingCodeBtn"
          :disabled="!show"
          style="margin-left: 10px"
          size="small">
          <span v-show="show">获取短信验证码</span>
          <span v-show="!show"
            class="count">{{ count }} s</span>
        </el-button>
      </el-form-item>
      <el-form-item prop="pass">
        <el-input type="password"
          v-model="formdata.pass"
          autocomplete="off"
          placeholder="请输入新密码"></el-input>
      </el-form-item>
      <el-form-item prop="checkPass">
        <el-input type="password"
          v-model="formdata.checkPass"
          autocomplete="off"
          placeholder="请再次输入新密码"></el-input>
      </el-form-item>
      <el-form-item class="login-form-btn">
        <el-button type="primary"
          style="width:100%"
          @click="changePassword('form')"
          :loading="loadingBtn">确认修改</el-button>
      </el-form-item>
    </el-form>
    <div v-if="showContent ==='success'">
      <el-result icon="success"
        title="密码修改成功"
        subTitle="请返回登录页重新登录！"
        style="padding-top:0">
      </el-result>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import {
  handleLoginErrorToast,
  handleLoginSuccessToast,
} from "@/assets/utils/handleData.js";
export default {
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.formdata.checkPass !== "") {
          this.$refs.form.validateField("checkPass");
        }
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.formdata.pass) {
        callback(new Error("您两次密码输入不一致，请重新输入!"));
      } else {
        callback();
      }
    };
    let checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号码不能为空"));
      }
      let regMobile =
        /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      if (!regMobile.test(value)) {
        callback(new Error("请输入正确的手机格式"));
      } else {
        callback();
      }
    };
    return {
      loadingCodeBtn: false,
      loadingBtn: false,
      showContent: "content",
      timer: null,
      count: null,
      show: true,
      formdata: {
        phone: "",
        code: "",
        phoneCode: "",
        pass: "",
        checkPass: "",
      },
      rules: {
        phone: [{ validator: checkPhone, trigger: "change" }],
        code: [{ required: true, message: "验证码不能为空", trigger: "blur" }],
        phoneCode: [
          { required: true, message: "短信验证码不能为空", trigger: "blur" },
        ],
        pass: [
          { validator: validatePass, trigger: "blur" },
          {
            pattern: /\S/,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            min: 8,
            max: 16,
            message: "请输入8-16位密码",
            trigger: "blur",
          },
          {
            pattern:
              /^(?!^\d+$)(?!^[a-z]+$)(?!^[A-Z]+$)(?!^[^a-z0-9]+$)(?!^[^A-Z0-9]+$)(?!^.*[\u4E00-\u9FA5].*$)^\S*$/,
            message: "包含数字/字母/特殊字符至少两种",
            trigger: "blur",
          },
        ],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
      },
      imgCode: {},
    };
  },
  methods: {
    sendCode() {
      this.$refs.form.validateField("phone", (errorMessage) => {
        if (errorMessage === "") {
          if (this.formdata.code == "") {
            this.$refs.form.validateField("code");
            return;
          }
          this.loadingCodeBtn = true;
          this.getSMSCode();
        }
      });
    },
    getCode() {
      if (!this.timer) {
        this.count = 60;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= 60) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    async getSMSCode() {
      let res = await api.loginGetSMSCode({
        phone: this.formdata.phone,
        captchaKey: this.imgCode.key,
        captcha: this.formdata.code,
      });
      if (res && res.status == 200) {
        this.loadingCodeBtn = false;
        if (res.data.code == 200) {
          if (handleLoginSuccessToast(res.data.data) !== "") {
            this.$message.success("发送验证码成功");
            this.getCode();
          } else {
            this.$message.error(handleLoginErrorToast(res.data.data));
          }
        }
      }
    },
    async getImgCode() {
      let res = await api.loginGetImgCode({});
      if (res && res.data.code == 200) {
        this.imgCode = res.data.data;
      }
    },
    changePassword(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.loadingBtn = true;
          let res = await api.loginSendChangePassword({
            phone: this.formdata.phone,
            smsCode: this.formdata.phoneCode,
            password: this.formdata.checkPass,
          });
          if (res && res.status == 200) {
            this.loadingBtn = false;
            if (res.data.code == 200) {
              if (handleLoginSuccessToast(res.data.data) !== "") {
                this.showContent = "success";
              } else {
                this.$message.error(handleLoginErrorToast(res.data.data));
              }
            }
          }
        }
      });
    },
  },
  created() {
    this.getImgCode();
  },
};
</script>

<style lang="scss" scoped>
.loginPageImgWrap {
  width: 43%;
  height: 40px;
  margin-left: 10px;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>